/**
 * Environment variables utility for the web application
 * This centralizes all environment variable access for better management
 */

import { z } from 'zod/v3';

// Environment type detection
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

// Environment validation
const _envSchema = z.object({
  DEV: z.boolean(),
  PROD: z.boolean(),
});

// Server configuration
export const SERVER_URL = (import.meta.env.VITE_SERVER_URL || 'http://localhost:15001').replace(/\/$/, '');
export const WEB_URL = (import.meta.env.VITE_WEB_URL || 'http://localhost:5173').replace(/\/$/, '');
export const APP_NAME = (import.meta.env.VITE_APP_NAME || 'Glyde');
export const APP_PUBLIC_URL = (import.meta.env.VITE_APP_PUBLIC_URL || 'https://screenata.com');

// Add performance flags
export const PERFORMANCE_FLAGS = {
  // Disable WebSockets for better bfcache support and performance
  DISABLE_WEBSOCKETS: import.meta.env.VITE_DISABLE_WEBSOCKETS === 'true',
  // Disable real-time collaboration for better performance
  DISABLE_COLLABORATION: import.meta.env.VITE_DISABLE_COLLABORATION === 'true',
  // Enable aggressive lazy loading
  ENABLE_AGGRESSIVE_LAZY_LOADING: import.meta.env.VITE_ENABLE_AGGRESSIVE_LAZY_LOADING !== 'false',
  // Disable analytics/tracking for better performance
  DISABLE_ANALYTICS: import.meta.env.VITE_DISABLE_ANALYTICS === 'true',
} as const;

export const EXTENSION_ID = import.meta.env.VITE_BROWSER_EXTENSION_ID;

// API endpoints
export const apiEndpoints = {
  // Server Root URL
  root: SERVER_URL,
  // API root
  api: `${SERVER_URL}/api`,
  // Regular chat endpoint
  chat: `${SERVER_URL}/api/ai/chat`,
  // Screenata-specific compliance chat endpoint
  // Screenata policy generation chat endpoint (Q&A + generate in one stream)
  // Screenata test-plan enhancement streaming endpoint
  
  // Stream article endpoint
  streamArticle: `${SERVER_URL}/api/ai/flow/generate`,

  // Stream SOP generation endpoint
  streamSop: `${SERVER_URL}/api/ai/flow/generate-sop`,

  // TRPC API endpoint
  trpcApi: `${SERVER_URL}/trpc`,
};

// Function to get API URL with optional path
export const getApiUrl = (path: string): string => {
  return `${SERVER_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
